// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3ZVIy","obliqueLineWrap":"membershipbadge_obliqueLineWrap__6rai1","obliqueLine":"membershipbadge_obliqueLine__1-3Uk"};